import { GetStaticPropsContext, GetStaticPropsResult } from 'next'

import LandingPage, { Props } from '@/features/landing/pages/Landing'

import { fetchAPI } from '@/lib/api'
import env from '@/lib/env'

export async function getStaticProps(
  _: GetStaticPropsContext,
): Promise<GetStaticPropsResult<Props>> {
  const response = await fetchAPI({
    url: env.PDPA_BLOG_API_URL,
    prefix: '/api/v1',
    path: '/pdpa/blogs',
    method: 'GET',
    headers: {
      'x-api-key': env.PDPA_BLOG_API_KEY,
    },
    params: {
      page: 0,
      per: 4,
    },
  })

  return {
    props: {
      blogList: response.data.data.slice(0, 4).map((blog: BlogInterface) => ({
        ...blog,
        link: `${env.APP_URL}${env.BLOG_BASE_PATH}/${blog.slug}`,
      })),
    },
    revalidate: 300,
  }
}

export default LandingPage
